import React from 'react';
import SignUpForm from 'Components/home/SignUpForm';
import HeroImage from 'Components/home/widgets/HeroImage';
import * as actions from 'Actions';
import { connect } from 'react-redux';
import classNames from 'classnames';

const textColor = (value, dark = '#0E2C44') =>
  value === 'light' ? '#FFFFFF' : dark;

class SignUp extends React.Component {
  render() {
    const {
      createUser,
      onSuccess,
      theme,
      storefrontHomeSetting,
      storefrontEventsSetting,
    } = this.props;
    const { homeVisible, homeCarouselItems } = storefrontHomeSetting;

    const isElaina = theme === 'elaina';
    const containsHomeImage = homeVisible && homeCarouselItems.length > 0;
    const shouldNotDisplayFigure = isElaina && !containsHomeImage;
    const displayTitle =
      storefrontEventsSetting.signupPageTitle || 'Sign Up for a New Way to Rent';
    const displayBody =
      storefrontEventsSetting.signupPageBody ||
      'Track rentals, make payments, request changes. You made it!';
    const headlineStyle = {
      color: textColor(storefrontEventsSetting.signupHeadlineTextColor),
    };
    const bodyStyle = {
      color: textColor(storefrontEventsSetting.signupBodyTextColor, '#466B88'),
    };

    return (
      <section
        className={classNames({
          signUp: true,
          authenticationNoImageContainer: shouldNotDisplayFigure,
        })}
      >
        <HeroImage
          shouldNotDisplayFigure={shouldNotDisplayFigure}
          picture={storefrontEventsSetting.customerPortalPicture}
          alt={displayTitle}
        />
        <div className={'details'}>
          <h1 id='signUpTitle' style={headlineStyle}>
            {displayTitle}
          </h1>
          <p style={bodyStyle}>{displayBody}</p>
        </div>
        <SignUpForm onSubmit={createUser} onSuccess={onSuccess} />
      </section>
    );
  }
}

const mapStateToProps = (state, _ownProps) => {
  const { parsedStorefrontSettings } = state.locations;
  const {
    mainSetting: { theme },
  } = parsedStorefrontSettings;

  return {
    theme,
    storefrontHomeSetting: parsedStorefrontSettings.storefrontHomeSetting,
    storefrontEventsSetting: parsedStorefrontSettings.storefrontEventsSetting,
  };
};

export default connect(mapStateToProps, actions)(SignUp);
